export const mergeStyles = (baseStyle, overrideStyle) => {
  const mergedStyle = { ...baseStyle };
  for (const key in overrideStyle) {
    if (typeof overrideStyle[key] === "object") {
      mergedStyle[key] = mergeStyles(baseStyle[key], overrideStyle[key]);
    } else {
      mergedStyle[key] = overrideStyle[key];
    }
  }
  return mergedStyle;
};
